import { useEffect, useState } from 'react';

import { featuresApi } from '@services/api/features';
import { getToken } from '@utils/auth';

export const DISABLED_FEATURES = { consolidated_export: false };

// Fail-closed: any error keeps every feature disabled.
export function useFeatures() {
  const [features, setFeatures] = useState(DISABLED_FEATURES);

  useEffect(() => {
    let active = true;

    featuresApi
      .getFeatures({ token: getToken({ type: 'client' }) })
      .then((response) => {
        if (active) {
          setFeatures({
            ...DISABLED_FEATURES,
            ...(response?.data?.features || {}),
          });
        }
      })
      .catch(() => {
        if (active) setFeatures(DISABLED_FEATURES);
      });

    return () => {
      active = false;
    };
  }, []);

  return features;
}

export default useFeatures;
